import TitleDashboard from '@components/general/Titles/TitleDashboard'
import { faBoxOpen, faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { obtenerEstadisticasEstudiante } from '@helpers/httpRequests/httpRequestsGruposLectura/httpRequestsGruposLectura'
import { useTheme } from '@mui/material'
import { MaterialReactTable } from 'material-react-table'
import { MRT_Localization_ES } from 'material-react-table/locales/es'
import React, { useMemo, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import { Button, Col, Container, Row, Spinner } from 'react-bootstrap'
import { FaBoxOpen } from 'react-icons/fa'

const AvanceGeneral = ({ setShowAvance, colaboradores, adminForo, usuarioLogeado }) => {

    const [comprension, setComprension] = useState([]);

    const [velocidad, setVelocidad] = useState([]);

    const [dataXComprension, setDataXComprension] = useState([])
    const [dataYComprension, setDataYComprension] = useState([])

    const [dataXVelocidad, setDataXVelocidad]= useState([]);
    const [dataYVelocidad, setDataYVelocidad]= useState([]);

    const [avancePersonal, setAvancePersonal] = useState({});

    const [showLoader, setShowLoader]= useState(false);

    const theme = useTheme()

    const getTestsSeguimiento = (data) => {
        let array = [];

        for (let index = 0; index < data.length; index++) {
            const element = data[index];

            array.push(`Test ${index + 1}`);
            
        }

        console.log(array)
        setDataXComprension(array);
    }

    const getDataComprension = (data) => {
        let array = [];

        for (let index = 0; index < data.length; index++) {
            const element = data[index];

            array.push(element.comprention);
            
        }
        console.log(array)
        setDataYComprension(array)
    }


    const getXDataVelocidad = (data) => {
        let array = [];

        for (let index = 0; index < data.length; index++) {
            const element = data[index];

            array.push(`Test ${index + 1}`);
            
        }

        console.log(array)
        setDataXVelocidad(array);
    }

    const getYDataVelocidad = (data) => {
        let array = [];

        for (let index = 0; index < data.length; index++) {
            const element = data[index];

            array.push(element.speed);
            
        }
        console.log(array)
        setDataYVelocidad(array)
    }

    const configComprension = {
        series: [
            {
                name: "Comprensión: ",
                data: dataYComprension,
            },
        ],
        options: {
            colors: ["#ff9900"],
            chart: {
                type: "bar",
                height: 380,
                zoom: {
                    enabled: false,
                },
            },
            xaxis: {
                categories: dataXComprension,
            },

            tooltip: {
                x: {
                    formatter: function (val) {
                        return val;
                    },
                },
            },
        },
    };

    const configVelocidad = {
        series: [
            {
                name: "ppm: ",
                data: dataYVelocidad,
            },
        ],
        options: {
            colors: ["#00152a"],
            chart: {
                type: "bar",
                height: 380,
                zoom: {
                    enabled: false,
                },
            },
            xaxis: {
                categories: dataXVelocidad,
            },

            tooltip: {
                x: {
                    formatter: function (val) {
                        return val;
                    },
                },
            },
        },
    };

    const columnas = useMemo(() => [
        
        {
            accessorKey: "nombreCompleto",
            header: "Nombre",
        },
        {
            accessorKey: "apellidos",
            header: "Apellidos",
        },
        
        
    ]);

    const obtenerUltimoEjercicio= (codigo) => {
        const semana = parseInt(codigo.slice(0, 2), 10);
        const dia = parseInt(codigo.slice(2, 4), 10);
        const sesion = parseInt(codigo.slice(4, 7), 10);
        const ejercicio = parseInt(codigo.slice(7, 9), 10);

        return `Semana: ${semana}, día: ${dia}, sesión: ${sesion}, ejercicio: ${ejercicio}`;
    }

    const handleEstadisticas = async (correo) => {
        try {
            setShowLoader(true);
            // console.log("Obteniendo estadisticas");
            // console.log(correo)
            const estadisticas = await obtenerEstadisticasEstudiante({ correo });
            console.log(estadisticas);


            getTestsSeguimiento(Array.isArray(estadisticas.comprention) ? estadisticas.comprention : [estadisticas.comprention] )
            getDataComprension(Array.isArray(estadisticas.comprention) ? estadisticas.comprention : [estadisticas.comprention] )

            getXDataVelocidad(Array.isArray(estadisticas.speed) ? estadisticas.speed : [estadisticas.speed])
            
            getYDataVelocidad(Array.isArray(estadisticas.speed) ? estadisticas.speed : [estadisticas.speed])

            setAvancePersonal(estadisticas.avancePersonal);

            setShowLoader(false);

            // if (Array.isArray(estadisticas)) {
            //     setComprension(estadisticas.speed);
            //     setVelocidad(estadisticas.speed);
            // } else {
            //     setComprension([estadisticas.comprention]);
            //     setVelocidad([estadisticas.speed]);
            // }
        } catch (error) {
            setShowLoader(false);
            setDataYVelocidad([]);
            setDataXVelocidad([]);
            setDataYComprension([]);
            setDataXComprension([]);

            setAvancePersonal({});

            console.log(error);
        }
    }

     // 👇 Filtro inicial si el usuario no es admin
            const [columnFilters, setColumnFilters] = useState(
                !adminForo
                ? [
                    {
                        id: 'correoDocente', // <- columna por la que filtras
                        value: usuarioLogeado.correo, // <- valor a filtrar
                    },
                    ]
                : []
            );

    return (
        <Container fluid className="mb-5 pb-5" style={{ minHeight: '60vh' }}>
            <Row className="mt-4 mb-3">
                <Col className='d-flex flex-row justify-content-between align-items-center'>
                    <h2>Progreso de los estudiantes</h2>
                    <Button onClick={() => setShowAvance(false)} className="mb-3 btn btn-danger"><FontAwesomeIcon icon={faClose} size='lg' /></Button>
                </Col>
            </Row>

            <Row className="mt-5">
                <Col>
                {/* <p><small>Utilíza <code>shift + rueda del mouse</code> sobre los registros para ver toda la información</small></p> */}
                    <MaterialReactTable
                        localization={MRT_Localization_ES}
                        columns={columnas}
                        data={colaboradores}
                        enableExpandAll={false}
                         state={{
                            columnFilters, // <- estado controlado del filtro
                        }}
                        onColumnFiltersChange={setColumnFilters} // <- importante para MRT v2
                        enableColumnFilters={adminForo} // los no admin no pueden cambiar filtros
                        enableGlobalFilter={adminForo} // los no admin no pueden buscar globalmente
                        enableSorting
                        enableColumnActions={adminForo}
                        enableFilterMatchHighlighting={false}
                        muiTableBodyRowProps={{
                            sx: {
                                '.Mui-TableBodyCell-DetailPanel': {
                                    backgroundColor:
                                        theme.palette.mode === 'dark'
                                            ? theme.palette.grey[900]
                                            : theme.palette.grey[100],
                                },
                            },
                        }}
                        //custom expand button rotation
                        muiExpandButtonProps={({ row, table }) => ({
                            onClick: () => {
                                table.setExpanded({ [row.id]: !row.getIsExpanded() });
                                if (!row.getIsExpanded()) {
                                    handleEstadisticas(row.original.correo);
                                }

                            }, //only 1 detail panel open at a time
                            sx: {
                                transform: row.getIsExpanded() ? 'rotate(180deg)' : 'rotate(-90deg)',
                                transition: 'transform 0.2s',
                            },
                        })}
                        renderDetailPanel={({ row }) => (
                            <Row className='d-flex align-items-center justify-content-around pt-4'>
                                {showLoader ? (
                                    <Row className='justify-content-center'>
                                        <Col className="col-auto">
                                            <Spinner color='#ff9900' animation={'border'} />
                                        </Col>
                                    </Row>
                                ): (
                                    (dataXComprension.length > 0 && dataYComprension.length > 0 && dataXVelocidad.length > 0 && dataYVelocidad.length > 0) ? (
                                        <> 
                                            <Col className='col-12 mb-4 mx-4'>
                                                <p>Nombre: <b>{avancePersonal.nombre}</b></p>
                                                <p>Palabras por minuto: <b>{avancePersonal.palabrasPorMinuto}</b></p>
                                                <p>Comprensión lectora: <b>{avancePersonal.comprension}</b></p>
                                                <p>Último ejercicio realizado: <b>{(avancePersonal.ultimoEjercicio === 'Sin avance' || avancePersonal.ultimoEjercicio === 'Curso terminado' || avancePersonal.ultimoEjercicio === 'Comenzando el curso') ? avancePersonal.ultimoEjercicio : obtenerUltimoEjercicio(avancePersonal.ultimoEjercicio)}</b></p>
                                            </Col>
                                            <Col className='col-4'>
                                                <TitleDashboard title={'Comprensión (%)'}/>
                                                <ReactApexChart options={configComprension.options} series={configComprension.series} type="bar" height="350" />
                                            </Col>
                                            <Col className='col-4'>
                                                <TitleDashboard title={'Velocidad de lectura (ppm)'}/>
                                                <ReactApexChart options={configVelocidad.options} series={configVelocidad.series} type="bar" height="350" />
                                            </Col>
                                        </>
                                    ): (
                                        <Row className='mt-3 mb-3'>
                                            <Col className='text-center'>
                                            <FontAwesomeIcon className='mb-3' icon={faBoxOpen} size={'4x'} color="#c0c0c0ff"/>
                                                <h3 style={{color: '#c0c0c0ff'}}>Sin información por mostrar </h3>
                                            </Col>
                                        </Row>
                                    )
                                    )}
                            </Row>

                        )}
                    // enableRowActions
                    // positionActionsColumn="last"
                    // renderRowActions={({ row, table }) => (
                    //     <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                    //         <IconButton color="primary" onClick={handleMenuSelection} id={row.original.idPersona}>
                    //             <MenuIcon />
                    //         </IconButton>
                    //     </Box>
                    // )}
                    />
                </Col>

            </Row>
        </Container>
    )
}

export default AvanceGeneral;